<template>
  <div>
    <v-data-table
      :headers="dataTable.headers"
      :items="getSchedulerTasks || []"
      class="my-3 border-2 cursor-pointer"
      :items-per-page="10"
      :loading="isLoading"
      :no-data-text="$t('noinfo')"
      :no-results-text="$t('no_matching_records_found')"
    >
      <template v-slot:item.active="{ item }">
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
            >
              <v-switch
                v-model="item.isActive"
                class="mt-0"
                color="primary"
                hide-details
                :disabled="isSaving || !item.contract.isActive"
                @change="changeActive($event, item)"
              ></v-switch>
            </div>
          </template>
          <span>{{ $t('bill.turn_on_or_off_auto_bill_work') }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.loopType="{ item }">
        <template v-if="item.loopType == 'everyday'">
          {{ $t('everyday') }}
        </template>
        <template v-else-if="item.loopType == 'everyweek'">
          {{ $t('everyday') }} {{ item.loopWeekDays.map(d => getDayString(d)).join(",") }}
        </template>
        <template v-else-if="item.loopType == 'everymonth'">
          {{ $t('every_day_format') }} {{ item.loopDate }}
        </template>
        <template v-else-if="item.loopType == 'manual'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">{{ $t('custom') }}</div>
            </template>
            <span>
              <div v-for="day in item.loopDays">
                {{ $moment(day).format("D MMM YYYY") }}
              </div>
            </span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:item.startDate="{ item }">
        {{ $moment(item.startDate.iso).format("D/MM/YYYY") }}
      </template>
      <template v-slot:item.endDate="{ item }">
        {{ $moment(item.endDate.iso).format("D/MM/YYYY") }}
      </template>
      <template v-slot:item.billCount="{ item }">
        {{ item.invoices ? item.invoices.length : 0 }}/{{ item.loopDays.length }}
      </template>
      <template v-slot:item.totalValue="{ item }">
        {{ item.data.totalValue | currencyPrefixSign(item.data.currencyCode) }}
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex justify-center">
          <v-btn
            class="mx-1"
            fab
            dark
            x-small
            color="info"
            @click="view(item)"
          >
            <v-icon dark>
              mdi-text-box-search-outline
            </v-icon>
          </v-btn>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div 
                v-bind="attrs"
                v-on="!enableEditInvoiceAndReceipt ? on : null"
              >
                <v-btn
                  v-if="item.contract.isActive"
                  class="mx-1"
                  fab
                  :dark="enableEditInvoiceAndReceipt"
                  x-small
                  color="orange"
                  @click="edit(item)"
                  :disabled="!enableEditInvoiceAndReceipt"
                >
                  <v-icon dark>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <span v-if="!enableEditInvoiceAndReceipt">{{ $t('validate.you_do_not_have_permission_to_edit_bill') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div 
                v-bind="attrs"
                v-on="!enableEditInvoiceAndReceipt ? on : null"
              >
                <v-btn
                  v-if="item.contract.isActive"
                  class="mx-1"
                  fab
                  :dark="enableEditInvoiceAndReceipt"
                  x-small
                  color="error"
                  @click="confirmRemove(item)"
                  :disabled="!enableEditInvoiceAndReceipt"
                >
                  <v-icon dark>
                    mdi-trash-can
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <span v-if="!enableEditInvoiceAndReceipt">{{ $t('validate.you_do_not_have_permission_to_edit_bill') }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <SchedulerTaskInvoiceDialog
      v-if="schedulerTaskId"
      v-model="isSchedulerTaskInvoiceDialog"
      :schedulerTaskId="schedulerTaskId"
      :contract="getContract"
      :marketId="getMarketId"
      :projectId="getProjectId"
      :mode="mode"
      @onSaveSuccess="onSaveSuccess"
      @onUpdateInvoice="onUpdateInvoice"
    />
    <ConfirmDialog 
      v-model="isRemoveConfirm" 
      :title="$t('validate.you_want_to_delete_this_bill')"
      type="error" 
      @onOk="remove()"
    />
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import SchedulerTaskInvoiceDialog from "./SchedulerTaskInvoiceDialog.vue";
import ConfirmDialog from "./ConfirmDialog.component.vue";
export default {
  props: {
    isLoading: Boolean,
  },
  components: { 
    SchedulerTaskInvoiceDialog,
    ConfirmDialog
  },
  data() {
    return {
      isSaving: false,
      isSchedulerTaskInvoiceDialog: false,
      schedulerTaskId: "",
      mode: "edit",
      isRemoveConfirm: false,
      dataTable: {
        headers: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      getProjectId: "markets/getProjectId",
      getContract: "contract/getContract",
      getMarketId: "markets/getMarketId",
      getSchedulerTasks: "schedulerTask/getSchedulerTasks",
    }),
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.getMarketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.getMarketId);
    },
    enableEditInvoiceAndReceipt() {
      let res = false;
      if (
        this.admin ||
        (this.admins && this.admins.length) ||
        (this.employee && this.employee.enableEditInvoiceAndReceipt)
      ) {
        res = true;
      }
      return res;
    },
  },
  created() {
    this.dataTable.headers = [
          {
            text: this.$t('usage'),
            value: "active",
          },
          {
            text: this.$t('name_of_setting'),
            value: "name",
          },
          {
            text: this.$t('bill.collect_bill_setting'),
            value: "loopType",
          },
          {
            text: this.$t('bill.number_of_export_bill'),
            value: "billCount",
          },
          {
            text: this.$t('bill.start_date'),
            value: "startDate",
          },
          {
            text: this.$t('bill.end_date'),
            value: "endDate",
          },
          {
            text: this.$t('market.total_value'),
            value: "totalValue",
          },
          {
            text: this.$t('manage'),
            value: "action",
            width: "160px",
            align: "center",
          },
    ];
  },
  methods: {
    onSaveSuccess(){
      this.$emit("onSaveSuccess");
    },
    onUpdateInvoice(){
      this.$emit("onUpdateInvoice");
    },
    edit(schedulerTask) {
      this.schedulerTaskId = schedulerTask.objectId;
      this.mode = "edit";
      this.isSchedulerTaskInvoiceDialog = true;
    },
    view(schedulerTask) {
      this.schedulerTaskId = schedulerTask.objectId;
      this.mode = "view";
      this.isSchedulerTaskInvoiceDialog = true;
    },
    confirmRemove(schedulerTask) {
      this.schedulerTaskId = schedulerTask.objectId;   
      this.isRemoveConfirm = true;
    },
    getDayString(day) {
      return this.$moment().day(day).format("dddd");
    },
    async changeActive(event, schedulerTask){
      this.isSaving = true
      try{
        await this.$store.dispatch("schedulerTask/updateSchedulerTask", {
          id: schedulerTask.objectId,
          isActive: event,
        })
        this.isSaving = false
        this.$toast.show({
          content: this.$t('save_success'),
          color: "success"
        })
      }catch(err){
        this.isSaving = false
        this.$toast.show({
          content: err.message,
          color: "error"
        })
      }
    },
    async remove() {
      try {
        this.isSaving = true
        await this.$store.dispatch("schedulerTask/removeSchedulerTask", this.schedulerTaskId)
        this.isSaving = false
        this.$toast.show({
          content: this.$t('delete_list_success'),
          color: "success"
        })
        this.isRemoveConfirm = false
        this.$emit("onSaveSuccess")
      } catch (error) {
        this.isSaving = false
        this.$toast.show({
          content: error.message,
          color: "error"
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-nowrap-table.loop-type{
  width: 100%;
}
</style>